import { useChatContext } from 'stream-chat-react';

import useGetUser from './useGetUser';

/**
 * Retrieves the chat title based on the channel type and its members.
 *
 * @returns The chat title: either the channel's `name` or the `name`
 * of another member (not the current user).
 */

function useChatTitle(): string {
	const { channel } = useChatContext();

	const member = useGetUser();

	if (!channel) return null;

	return channel.data?.name || member?.user?.name || 'Unknown chat';
}

export default useChatTitle;
